<template>
  <fh-list-container v-if="userInfo.orgId !== kaixianOrgId" :entityId="entity"></fh-list-container>
  <ly-list v-else :entityId="entity"></ly-list>
</template>

<script setup>
import { kaixianOrgId } from '@/utils/const';
import { useUserStore } from '@/store';
import FhListContainer from '@/components/fh-list/fh-list-container/fh-list-container.vue';
defineProps({
  entity: {
    //对象的entity【系统对象时必传】
    type: Number || String,
    default: ''
  }
});
const { userInfo } = useUserStore(); //用户信息
</script>
<style scoped lang="less">
@import './sys-obj.less';
</style>
